import { IDeliveryTimeSlotData } from "@/entities/deliveryTimeSlot";
import { IDeliverySlotRepository } from ".";
import axios from "axios";

const ENDPOINT =
    "https://gm6k60bdz5.execute-api.ap-southeast-1.amazonaws.com/Prod";

export class DeliverySlotAPIRepository implements IDeliverySlotRepository {
    async check(
        branchCode: number,
        dateSlot: string
    ): Promise<IDeliveryTimeSlotData> {
        const input = {
            branch_code: branchCode,
            date_slot: dateSlot,
        };

        const response = await axios.post(`${ENDPOINT}/checkSlot`, input);
        
        console.log(response);

        return response.data as IDeliveryTimeSlotData;
    }

    async book(
        branchCode: number,
        dateSlot: string,
        orderId: string,
        bookingHour: number,
        premium: boolean
    ): Promise<void> {
        return;
    }
}
